import { render, staticRenderFns } from "./IframeSet.vue?vue&type=template&id=945d9238&scoped=true&"
import script from "./IframeSet.vue?vue&type=script&lang=js&"
export * from "./IframeSet.vue?vue&type=script&lang=js&"
import style0 from "./IframeSet.vue?vue&type=style&index=0&id=945d9238&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945d9238",
  null
  
)

export default component.exports